/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export const ro = {
  'sharedComponents': {
    'dateRange': {
      'start': 'Start...',
      'end': 'Sfârșit...'
    },
    'search': 'Cauta',
    'timeInterval': {
      'startTime': 'HH:mm ex: 08:00',
      'endTime': 'HH:mm ex: 16:00'
    },
    'numberInterval': {
      'startNumber': 'Start...',
      'endNumber': 'Sfârșit...'
    },
    'attachments': {
      'confirmDeletionMessage':'Sunteti sigur ca doriti sa stergeti acest fisier?',
      'confirmationHeader': 'Confirmati',
      'confirmed': 'Confirmat',
      'fileRemoved':'Fisierul a fost sters cu succes!',
      'maxFileSizeMessage': '',
      'invalidFileSizeMessageSummary': 'Limita atinsa!',
      'invalidFileSizeMessageDetail': 'Un fisier nu poate depasi dimensiunea de 2MB.',
      'invalidTotalFileSizeMessageSummary': 'Limita totala atinsa!',
      'invalidTotalFileSizeMessageDetail': 'Dimensiunea tuturor fisierelor nu poate depasi 10MB.'
    }
  },
  'resource-availability': {
    'resType': 'Tip resursă',
    'resRole': 'Rol resursă',
    'availability': 'Disponibilitate',
    'name': 'Nume',
    'department': 'Departament',
    'delegation': 'Delegatie',
    'partTimeDelegation': 'Delegatie partiala',
    'fullTimeDelegation': 'Delegatie pe toata perioada',
    'selectResType': 'Selectează tipul de resursă',
    'selectRole': 'Selectează rol',
    'search': 'Caută'
  },
  "pwl": {
    "detail_title": "Person details",
    "list_title": "People",
    "name": "Name",
    "address": "Address",
    "cnp": "Cnp",
    "idSeries": "ID Series",
    "idNumber": "ID Number",
    "county": "County",
    "edit": "Edit",
    "remove": "Delete",
    "back": "Back",
    "yes": "Yes",
    "no": "No",
    "search": "Search",
    "save": "Save",
    "person_delete": "Delete this person?",
    "person_create": "Create person",
    "person_edit": "Edit person",
    "confirm_delete": "Delete confirmation",
    "reset": "Reset"

  },
  "fwl": {
    "detail_title": "Detalii firma",
    "list_title": "Firme",
    "name": "Nume",
    "cif": "Cif",
    "address": "Adresa",
    "county": "Județ",
    "nrComReg": "Număr registru comerț",
    "phone": "Telefon",
    "fax": "Fax",
    "capital": "Capital",
    "bankAccounts": "Conturi Bancare",
    "bank": "Bancă",
    "account": "Cont",
    "edit": "Editează",
    "remove": "Șterge",
    "back": "Înapoi",
    "yes": "Da",
    "no": "Nu",
    "search": "Caută",
    "save": "Salvează",
    "firm_delete": "Ștergeți această firmă?",
    "firm_create": "Creează firmă",
    "firm_edit": "Editează firmă",
    "confirm_delete": "Confirmare ștergere",
    "createBankAccount": "Creează cont bancar",
    "reset": "Resetează"

  }
};
